import { render, staticRenderFns } from "./ScoreCardItemTotalV3.vue?vue&type=template&id=7754c5e1&scoped=true&"
import script from "./ScoreCardItemTotalV3.vue?vue&type=script&lang=js&"
export * from "./ScoreCardItemTotalV3.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardItemTotalV3.vue?vue&type=style&index=0&id=7754c5e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7754c5e1",
  null
  
)

export default component.exports